import useNextLesson from "./next-lesson";

const JWPlayerConfig = (
  playerRef,
  videoConfig,
  router,
  startCourse,
  videoData,
  handleProgress,
  isStandaloneCourse,
  getLessons,
  isLPIntoVideo,
  isLast,
  autoStart = true,
  isTrailerVideo = false,
  setShowAlertNudge,
  incrementAttempts,
  isLpCourse,
  setShowSurvey
) => {
  const nextLesson = useNextLesson(videoConfig, router);
  if (playerRef && videoData?.file) {
    const playerInstance = jwplayer(playerRef);

    // Get caption URL from Video component's subtitle processing
    const captionUrl = playerRef?.dataset?.captionUrl;

    if (typeof window !== "undefined") {
      const videoModal = document.getElementById("modal-jw");

      if (videoModal) {
        // Pause on close of modal
        videoModal.addEventListener("hide.bs.modal", (event) => {
          playerInstance.pause();
        });
      }
    }
    playerInstance.setup({
      // "playlist": playlist,
      file: videoData.file,
      image: videoData.image,
      title: videoData?.title,

      aspectratio: "16:9",
      autoPause: {
        viewability: false,
      },
      // "autostart":  startCourse || currentLesson > 0,
      autostart: autoStart || isStandaloneCourse,
      captions: {
        backgroundColor: "#000000",
        backgroundOpacity: 75,
        color: "#FFFFFF",
        edgeStyle: "none",
        fontFamily: "Inter",
        fontOpacity: 100,
        fontSize: 12,
        windowColor: "#000000",
        windowOpacity: 0,
        padding: 10,
      },
      controls: true,
      playbackRateControls: true, // Enable playback rate control
      playbackRates: [0.5, 1, 1.5, 2], // Customize playback rate options
      displayHeading: false,
      displaydescription: false,
      displaytitle: false,
      floating: {
        mode: "never",
      },
      generateSEOMetadata: false,
      include_compatibility_script: false,
      interactive: false,
      intl: {
        en: {
          sharing: {
            heading: "Share Video",
          },
        },
      },
      logo: {
        hide: false,
        position: "top-right",
      },
      mute: false,
      pipIcon: "disabled",
      preload: "metadata",
      repeat: false,
      sharing: true,
      sharingConfig: {
        link: window.location.toString(),
        // code: "<iframe src='YOUR_EMBED_CODE'></iframe>",
        heading: "Share This Video",
        sites: ["facebook", "twitter", "linkedin", "email"], // Include multiple sharing options
      },
      stretching: "uniform",
      width: "100%",
      previewThumbnails: true,
      tracks: captionUrl
        ? [
            {
              file: captionUrl,
              kind: "captions",
              label: "English",
              language: "en",
              default: true,
            },
          ]
        : undefined,
      // "start": videoData?.approxTime > 0 ? parseInt(videoData?.approxTime) : 0,
      // "defaultPlaybackRate": {
      //   "start": videoData?.approxTime > 0 ? parseInt(videoData?.approxTime) : 0 // Start the video at 60 seconds (1 minute)
      // }
    });

    // Start the video playback from a specific time (e.g., 60 seconds)
    playerInstance.on("ready", function () {
      // playerInstance.seek(60);
      if (videoData?.approxTime > 0) {
        playerInstance.seek(videoData?.approxTime); // Start the video at 60 seconds (1 minute)
      }
    });

    // Lesson/Video begins playing
    playerInstance.on("firstFrame", function (e) {
      handleProgress({ key: "hasStarted", value: true });
      if (videoData?.approxTime > 0) {
        playerInstance.seek(videoData?.approxTime); // Start the video at 60 seconds (1 minute)
      }
      // playerInstance.seek(60);
    });

    // Lesson/Video is being played
    let nextUpdateTime = 0;
    let updateInterval;
    playerInstance.on("time", function (e) {
      if (!updateInterval) {
        updateInterval = e.duration / 10;
      }

      if (e.position >= nextUpdateTime) {
        const percentageComplete = (e.position / e.duration) * 100;
        handleProgress({ key: "percentage", value: percentageComplete });
        nextUpdateTime += updateInterval;
      }
    });

    // Lesson/Video is being paused
    playerInstance.on("pause", function (e) {
      if (isTrailerVideo) {
        return;
      }
      const position = jwplayer().getPosition();
      const duration = jwplayer().getDuration();
      const percentageComplete = (position / duration) * 100;
      if (isStandaloneCourse) {
        handleProgress({ key: "percentage", value: percentageComplete }, true);
      }
      handleProgress({ key: "percentage", value: percentageComplete });
    });

    // Lesson/Video Completed
    !isLPIntoVideo &&
      playerInstance.on("complete", async function (e) {
        if (isTrailerVideo) {
          return;
        }
        if (isLast) {
          await handleProgress({ key: "percentage", value: 100 });
          await handleProgress({ key: "isCompleted", value: true });
          getLessons();
          // incrementAttempts();
          setShowSurvey(true);
          setShowAlertNudge(true);
          return;
        }

        let totalLessons = videoConfig?.totalLessons;
        let currentLesson = Object.values(videoConfig).findIndex(
          (config) => config.url === window.location.pathname
        );
        const percentageComplete = (currentLesson / totalLessons) * 100;

        if (percentageComplete !== null) {
          if (isStandaloneCourse) {
            handleProgress({ key: "percentage", value: 100 }, true);
            if (isLpCourse) {
              // setShowAlertNudge(true);
            }
          } else {
            await handleProgress(
              { key: "percentage", value: percentageComplete },
              true
            );
            incrementAttempts();
          }
          await handleProgress({ key: "percentage", value: 100 });
          await handleProgress({ key: "isCompleted", value: true });
          getLessons();
        }
        nextLesson();
      });
  }
};

export default JWPlayerConfig;
